import React, { useState } from 'react';
import { 
  Tooltip, 
  IconButton, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button,
  Typography,
  Box,
  Stack
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import ErrorIcon from '@mui/icons-material/Error';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';

interface VerificationBadgeProps {
  verified?: boolean;
  userId: string;
  onStatusChange: (userId: string, newStatus: boolean) => Promise<void>;
}

export const VerificationBadge: React.FC<VerificationBadgeProps> = ({ verified, userId, onStatusChange }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleVerificationClick = () => {
    setDialogOpen(true);
  };

  const handleConfirm = async () => {
    await onStatusChange(userId, !verified);
    setDialogOpen(false);
  };

  return (
    <>
      <Tooltip title={verified ? 'Compte vérifié' : 'Compte non vérifié'}>
        <IconButton onClick={handleVerificationClick} size="small">
          {verified ? (
            <VerifiedIcon color="success" />
          ) : (
            <ErrorIcon color="error" />
          )}
        </IconButton>
      </Tooltip>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>
          Confirmation du changement de statut
        </DialogTitle>
        <DialogContent>
          <Typography>
            Êtes-vous sûr de vouloir {verified ? 'retirer la vérification' : 'vérifier'} ce compte ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Annuler</Button>
          <Button onClick={handleConfirm} autoFocus>
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
